import React from 'react';
import { Form, TimePicker } from 'antd';
import { DATETIME_FORMAT_TIME } from '../../../../utils/helpers/CommonHelper';

//https://ant.design/components/date-picker/
const FormRangeTimePicker = ({
  label,
  name,
  rules,
  format = DATETIME_FORMAT_TIME,
  ...rest
}) => {
  return (
    <Form.Item label={label} name={name} rules={rules}>
      <TimePicker.RangePicker format={format} {...rest} />
    </Form.Item>
  );
};

export default FormRangeTimePicker;
